export const ALL_WAVES: Wave2[] = [
  202502, 202501, 202402, 202401, 202301, 202302, 202202, 202201, 2021, 2020,
  2019, 2018, 2017, 2016, 2015, 2014
];

export const LAST_WAVES: Wave2[] = [
  202502, 202501, 202402, 202401, 202301, 202302, 202202, 202201, 2021, 2020
];

export const ALL_MARKETS: Market2[] = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 44
];
